"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RioNotifications = void 0;
var Notifications_1 = require("./components/Notifications");
Object.defineProperty(exports, "RioNotifications", { enumerable: true, get: function () { return Notifications_1.Notifications; } });
if (typeof window !== 'undefined') {
    window.RioNotifications = {
        RioNotifications: Notifications_1.Notifications,
    };
}
